import { ElevationScroll } from "./ElevationScroll";
import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { observer } from "mobx-react";
import useMeasure from "react-use-measure";

type HeaderBarProps = {
  updateHeight: (size: number | undefined) => void;
  headerChildren?: React.ReactElement | React.ReactElement[];
};

export const HeaderBar: React.FC<HeaderBarProps> = observer(
  ({ updateHeight, headerChildren = <div /> }) => {
    const [measureRef, bounds] = useMeasure();
    const lastReportedHeight = useRef<number | undefined>();

    useEffect(() => {
      const currentHeight = bounds.height;
      if (currentHeight > 0 && currentHeight !== lastReportedHeight.current) {
        updateHeight(currentHeight);
        lastReportedHeight.current = currentHeight;
      } else if (
        lastReportedHeight.current !== undefined &&
        currentHeight <= 0
      ) {
        updateHeight(0);
        lastReportedHeight.current = 0;
      }
    }, [bounds.height, updateHeight]);

    return (
      <ElevationScroll>
        <div>
          <Box ref={measureRef}>{headerChildren}</Box>
        </div>
      </ElevationScroll>
    );
  }
);
